import { render, staticRenderFns } from "./BlockType18.vue?vue&type=template&id=06666d10&scoped=true"
import script from "./BlockType18.vue?vue&type=script&lang=ts"
export * from "./BlockType18.vue?vue&type=script&lang=ts"
import style0 from "./BlockType18.vue?vue&type=style&index=0&id=06666d10&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06666d10",
  null
  
)

export default component.exports